import React from 'react';

export interface ConversationContextIF {
  takeOverInterpreter(interpreterKey: string | undefined, text: string): void;
}

export const ConversationContext = React.createContext<ConversationContextIF | undefined>(
  undefined
);
